// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"2c12c35b","726":"816655bb"}[chunkId] + ".chunk.js";
};